import { z } from "zod";
import { defineEvent } from "./registry.js";
/** İstasyonda fiyat yürürlüğe girdi. İstasyon ajanı (Prompt 14) bu olayla pompa fiyatlarını günceller. */
export const priceChangedV1 = defineEvent({
    type: "pricing.price.changed",
    version: 1,
    description: "İstasyonda bir ya da daha çok ürünün fiyatı yürürlüğe girdi",
    realtime: ["tenant", "station"],
    payload: z.object({
        stationId: z.uuid(),
        priceListId: z.uuid(),
        requestId: z.uuid().nullable(),
        requestNo: z.string().nullable(),
        effectiveAt: z.iso.datetime({ offset: true }),
        prices: z.array(z.object({ productId: z.uuid(), unitPrice: z.string(), previousUnitPrice: z.string().nullable() })),
    }),
});
export const priceChangeScheduledV1 = defineEvent({
    type: "pricing.change_request.scheduled",
    version: 1,
    description: "Fiyat değişikliği onaylandı ve ileri tarihe planlandı",
    realtime: ["tenant"],
    payload: z.object({
        requestId: z.uuid(),
        requestNo: z.string(),
        effectiveAt: z.iso.datetime({ offset: true }),
        stationIds: z.array(z.uuid()),
    }),
});
export const priceChangeCancelledV1 = defineEvent({
    type: "pricing.change_request.cancelled",
    version: 1,
    description: "Planlanmış fiyat değişikliği iptal edildi",
    realtime: ["tenant"],
    payload: z.object({ requestId: z.uuid(), requestNo: z.string() }),
});
//# sourceMappingURL=pricing.v1.js.map